import React, { forwardRef, useImperativeHandle, useState } from 'react';

import { TextInput } from 'nhsuk-react-components';

const TextArea = forwardRef((props, ref) => {
    const [error, setError] = useState(undefined);
    const [isValid, setIsValid] = useState(undefined);

    useImperativeHandle(ref, () => ({
        validate,
        isValid
    }));

    const validate = () => {
        if (props.question.value === null) {
            if (props.question.mandatory) {
                setIsValid(false);
                setError('Please enter a mobile number');
                return;
            } else {
                setError(undefined);
                setIsValid(true);
                return;
            }
        }

        if (isValidUKPhoneNumber(props.question.value)) {
            setError(undefined);
            setIsValid(true);
        } else {
            setIsValid(false);
            setError('Please enter a valid mobile number');
        }
    };

    function isValidUKPhoneNumber(input) {
        const cleaned = input.startsWith('+')
            ? '+' + input.slice(1).replace(/\D/g, '')
            : input.replace(/\D/g, '');

        props.question.value = cleaned;

        if (cleaned.startsWith('+44')) {
            return /^\+44\d{10}$/.test(cleaned);
        }

        if (cleaned.startsWith('0')) {
            return /^0\d{9,10}$/.test(cleaned);
        }

        return false;
    }

    const getValue = () => {
        if (props.question.value === undefined) {
            props.question.value = null;
        }
        return props.question.value ?? '';
    };

    const handleChange = async event => {
        props.question.value = event.target.value;
        await props.onChange({
            questionId: props.question.id,
            value: props.question.value
        });
        validate();
    };

    const value = getValue();

    return (
        <TextInput
            id={props.id}
            label={props.question.name}
            hint={props.question.hint_text}
            error={error}
            width={'10'}
            value={value}
            onChange={handleChange}
            onBlur={handleChange}
            disabled={props.question.isReadOnly}
            required={props.question.mandatory}
        />
    );
});

export default TextArea;
